<template>
  <v-container fluid class="mx-0 px-0">
    <template v-if="showFail">
      <v-row align="baseline" class="mb-0">
        <v-col cols="12">
          <el-savitarna-alert dense outlined type="error">
            {{ failMsg }}
          </el-savitarna-alert>
        </v-col>
      </v-row>
    </template>
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :item-class="rowClass"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: this.$t('Rodyti po:'),
        itemsPerPageAllText: this.$t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top v-if="showPridetiAsmeni">
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <el-button-prideti small primary @click.native.stop="newItem()">
            {{ $t('Pridėti asmenį') }}
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template v-slot:body="{ items }">
        <tbody>
          <template v-for="(item, index) in items">
            <tr
              :key="`a-${index}-1`"
              :class="forceHover(index)"
              @mouseenter="mouseEnter(index)"
              @mouseleave="mouseLeave()"
            >
              <td>
                <v-row dense no-gutters>
                  <v-col cols="12" md="12">
                    {{ item.asm_pavadinimas }}
                  </v-col>
                  <v-col cols="12" md="12">
                    {{ item.asm_asmens_kodas }}
                  </v-col>
                  <v-col cols="12" md="12" v-if="item.yra_mires">
                    <span class="text-gray">({{ $t('asmuo miręs') }})</span>
                  </v-col>
                  <v-col cols="12" md="12" v-if="!hideSalis">
                    {{ item.asmuoRole }}
                  </v-col>
                </v-row>
              </td>
              <td>
                <v-row dense no-gutters>
                  <v-col cols="12" md="12">
                    {{ item.adr_text }}
                  </v-col>
                  <v-col cols="12" md="12">
                    {{ item.sasm_el_pastai.join(', ') }}
                  </v-col>
                </v-row>
              </td>
              <td
                :rowspan="item.isAtstovas ? 2 : 1"
                v-if="!hidePatvirtinimas"
                :class="item.isLast ? 'table-no-bottom-border' : ''"
              >
                {{ item.patvirtinimas }}
              </td>
              <td
                :rowspan="item.isAtstovas ? 2 : 1"
                :class="item.isLast ? 'table-no-bottom-border' : ''"
              >
                <el-table-action
                  :item="item"
                  @editItem="editItem(item)"
                  @viewItem="editItem(item)"
                  @deleteItem="deleteItem(item)"
                  @addAtstovas="addAtstovas(item.atstovas)"
                  @editAtstovas="editAtstovas(item.atstovas)"
                  @viewAtstovas="editAtstovas(item.atstovas)"
                  @deleteAtstovas="deleteAtstovas(item.atstovas)"
                />
              </td>
            </tr>
            <tr
              :key="`a-${index}-2`"
              v-if="item.isAtstovas"
              :class="forceHover(index)"
              @mouseenter="mouseEnter(index)"
              @mouseleave="mouseLeave()"
            >
              <td colspan="2">
                <v-row dense no-gutters>
                  <v-col cols="12" md="12">
                    <span class="text-gray">{{ $t('Atstovas') }}:</span>
                  </v-col>
                  <v-col cols="12" md="12">
                    <span class="text-gray">{{
                      item.atstovas_pavadinimas
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="12">
                    <span
                      class="text-gray"
                      v-html="item.atstovas_veikiantis_nowrap"
                    ></span>
                  </v-col>
                  <v-col cols="12" md="12">
                    <span
                      class="text-warning"
                      v-html="item.atstovas_ispejimas"
                    ></span>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
      <template slot="loading">
        {{ $t('Kraunasi...') }}
      </template>
      <template slot="no-results">
        {{ $t('Duomenų nėra') }}
      </template>
      <template slot="no-data">
        {{ $t('Duomenų nėra') }}
      </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-prasymas-asmuo
      :key="modalAsmuoKey"
      v-model="showAsmuo"
      :asmuo="modalAsmuo"
      :asmuo-role="modalAsmuoRole"
      :change-role="modalChangeRole"
      :parent-atstovas-id="modalParentAtstovasId"
      :salys="salys"
      :readonly="modalAsmuoReadonly"
      :save-fail="modalAsmuoSaveFail"
      @savedData="saveAsmuo"
      @savedAtstovas="savedAtstovas"
    />

    <modal-delete
      :title="$t('Šalinti asmenį?')"
      :text="
        $t('Ar norite pašalinti asmenį') +
          ` <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalPrasymasAsmuo from '../modals/ModalPrasymasAsmuo'
import ModalDelete from '../modals/ModalDelete'
import NtrPaslaugosMap from './NtrPaslaugosMap'
import rowClass from '@/mixins/rowClass'
import busena from '@/mixins/busenaNtr'
import userRole from '@/mixins/userRole'
import checkErrors from '@/mixins/checkErrors'

export default {
  name: 'PrasymasAsmenys',
  components: {
    ModalPrasymasAsmuo,
    ModalDelete,
  },
  props: {
    readonly: { type: Boolean, default: false },
  },
  mixins: [busena, rowClass, userRole, checkErrors],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showAsmuo: false,
      modalAsmuoReadonly: false,
      modalAsmuoKey: 'asmuo',
      modalAsmuoRefresh: 0,
      modalAsmuoRole: null,
      modalChangeRole: false,
      modalParentAtstovasId: null,
      modalAsmuo: {},
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      modalDeleteRole: null,
      asmenys: [],
      salys: [],
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      showFail: false,
      failMsg: null,
      modalAsmuoSaveFail: false,
      activeRow: null,
    }
  },
  computed: {
    ...mapGetters(['prasymasID', 'prasymasSistema']),
    isSistemaSavitarna() {
      return this.prasymasSistema === 'savitarna'
    },
    headers() {
      return [
        {
          text: this.$t('Asmuo'),
          align: 'start',
          value: 'asmuo',
          width: 220,
        },
        {
          text: this.$t('Kontaktai'),
          align: 'start',
          value: 'kontaktai',
        },

        {
          text: this.$t('Patvirtinimas'),
          align: 'center',
          value: 'patvirtinimas',
          width: 100,
          hide: this.hidePatvirtinimas,
        },
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 50,
        },
      ]
    },
    hideSalis() {
      return this.isPrasymasSeima || this.isPrasymasBendra
    },
    hidePatvirtinimas() {
      return (
        !this.isSistemaSavitarna ||
        (this.isPrasymasSeima &&
          this.isPrasymasIsregistravimas &&
          !this.isSutuoktiniuPrasymu) ||
        (this.isPrasymasNuoma && this.isPrasymasIsregistravimas) ||
        (this.isPrasymasPanauda && this.isPrasymasIsregistravimas) ||
        (this.isPrasymasSubnuoma && this.isPrasymasIsregistravimas) ||
        (this.isPrasymasPreliminari && this.isPrasymasIsregistravimas)
      )
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.asmenys.map((item, index) => {
        item.asmuoRole = NtrPaslaugosMap.getAsmuoRole(
          item.sasm_role_objekte
        ).title

        if (!item.asm_asmens_kodas) {
          item.asm_asmens_kodas = item.asm_gimimo_data
        }

        item.canEdit = !this.formReadonly
        item.canView = this.formReadonly
        item.canDelete = !this.formReadonly && item.galima_salinti
        item.readonly = this.formReadonly

        if (this.isRengiamas) {
          item.patvirtinimas = null
        }

        item.atstovas = {}
        if (item.tipas === 'JUR') {
          item.atstovas = {
            parent_atstovas_id: item.sasm_id,
            sasm_id: item.atstovas_sasm_id,
            asm_pavadinimas: item.atstovas_pavadinimas,
            sasm_role_objekte: 'atstovas',
          }
          if (item.atstovas_sasm_id) {
            item.canViewAtstovas = true
            item.canEditAtstovas = false
            item.canDeleteAtstovas =
              !this.formReadonly &&
              item.atstovas_galima_salinti &&
              this.showAtstovas
          } else {
            item.canAddAtstovas =
              item.canEdit && item.atstovas_galima_salinti && this.showAtstovas
          }
        }

        item.isAtstovas = item.atstovas_sasm_id
        item.isLast = index === this.asmenys.length - 1

        // item.atstovas_veikiantis =
        //   'Veikiantis pagal įgaliojimą Nr. 18939, registravimo data 2022-08-19, terminas 2024-08-18'

        item.atstovas_veikiantis_nowrap = ''
        if (item.atstovas_veikiantis) {
          item.atstovas_veikiantis_nowrap = `<span class="nowrap">${item.atstovas_veikiantis.replaceAll(
            ',',
            ',</span> <span class="nowrap">'
          )}</span>`
        }
        if (item.atstovas_ispejimas) {
          item.atstovas_ispejimas = item.atstovas_ispejimas.replace(
            '.',
            '. <br/>'
          )
        }
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    formReadonly() {
      return this.readonly
    },
    showPridetiAsmeni() {
      return (
        !this.formReadonly &&
        ((this.isPrasymasSeima &&
          this.isPrasymasIsregistravimas &&
          !this.isSutuoktiniuPrasymu) ||
          (this.isPrasymasNuoma && this.isPrasymasIregistravimas) ||
          (this.isPrasymasPanauda && this.isPrasymasIregistravimas) ||
          (this.isPrasymasSubnuoma && this.isPrasymasIregistravimas) ||
          (this.isPrasymasPreliminari && this.isPrasymasIregistravimas)) &&
        this.isRengiamas
      )
    },
    isNuoma() {
      return this.isPrasymasNuoma
    },
    isPanauda() {
      return this.isPrasymasPanauda
    },
    isSubnuoma() {
      return this.isPrasymasSubnuoma
    },
    isPreliminari() {
      return this.isPrasymasPreliminari
    },
    asmuoRole() {
      if (this.isPrasymasPanauda) {
        return 'panauda_gavejas'
      }
      if (this.isPrasymasNuoma) {
        return 'nuomininkas'
      }
      if (this.isPrasymasSubnuoma) {
        return 'subnuomininkas'
      }
      if (this.isPrasymasPreliminari) {
        return 'pardavejas'
      }
      return 'savininkas'
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    showAtstovas() {
      return (
        this.isPrasymasNuoma ||
        this.isPrasymasPanauda ||
        this.isPrasymasSubnuoma ||
        this.isPrasymasPreliminari
      )
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/asmuo`)
        .then(res => {
          this.asmenys = res.data.asmenys
          this.salys = res.data.salys
          this.updateErrors()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.showFail = false
        })
    },
    editItem(item) {
      this.openAsmuo(item)
    },
    newItem() {
      if (
        this.isPrasymasSeima &&
        this.isPrasymasIsregistravimas &&
        this.asmenys.length == 2
      ) {
        this.failMsg = this.$t(
          'Jau įvesti buvusio sutuoktinio duomenys. Dviejų asmenų pridėjimas negalimas.'
        )
        this.showFail = true
        return
      }
      this.openAsmuo({})
    },
    openAsmuo(item) {
      this.showFail = false
      this.modalAsmuo = {
        asm_asmens_kodas_jur: null,
        asm_pavadinimas: null,
        asm_asmens_kodas_fiz: null,
        asm_asmens_kodas: this.isLocal ? '39000000000' : null,
        asm_fiz_vardas: this.isLocal ? 'PETRAS' : null,
        asm_fiz_pavarde: this.isLocal ? 'PETRAUSKAS' : null,
        asm_gimimo_data: null,
        asm_vls_kodas: null,
        ...item,
        adresas: {
          text: item.adr_text,
        },
      }
      this.modalAsmuoReadonly = item.readonly
      this.modalAsmuoRole = item.sasm_role_objekte ?? this.asmuoRole
      this.modalChangeRole = !item.sasm_id //|| item.galima_salinti
      this.modalParentAtstovasId = null
      this.modalAsmuoSaveFail = false
      this.modalAsmuoKey =
        'asmuo' + (item.sasm_id ?? 'new' + this.modalAsmuoRefresh++)
      this.showAsmuo = true
    },
    saveAsmuo(asmuo) {
      const data = {
        sasm_id: asmuo.sasm_id,
        pra_id: this.prasymasID,
        amn_id: asmuo.amn_id,
        sasm_role_objekte:
          this.isNuoma ||
          this.isPanauda ||
          this.isSubnuoma ||
          this.isPreliminari
            ? asmuo.sasm_role_objekte
            : this.asmuoRole,
        tipas: asmuo.tipas,
        sasm_el_pastas: asmuo.sasm_el_pastas,
        adresas: {
          adresas_foreign: false,
          text: asmuo.adresas.text,
        },
        asm_asmens_kodas: asmuo.asm_asmens_kodas,
        asm_kodo_tipas: asmuo.asm_kodo_tipas,
      }
      this.modalAsmuoSaveFail = false

      this.$axios
        .post(`ntrpaslaugos/prasymas/${this.prasymasID}/asmuo`, data)
        .then(res => {
          this.modalAsmuoKey = 'asmuo'
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
          this.showAsmuo = false
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.modalAsmuoSaveFail = true
        })
        .finally(() => {
          this.loading = false
          this.showFail = false
        })
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.asm_pavadinimas
      this.modalDeleteItem = Object.assign({}, item)
      this.modalDeleteRole = item.sasm_role_objekte
      this.showDelete = true
    },
    confirmDelete(item) {
      this.confirmDeleteAsmuo(item)
    },
    confirmDeleteAsmuo(item) {
      this.loading = true

      this.$axios
        .delete(
          `ntrpaslaugos/prasymas/${this.prasymasID}/asmuo/${item.sasm_id}/${this.modalDeleteRole}`
        )
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.showFail = false
        })
    },
    addAtstovas(item) {
      this.openAtstovas(null, item.parent_atstovas_id)
    },
    editAtstovas(item) {
      this.openAtstovas(item.sasm_id, item.parent_atstovas_id, true)
    },
    openAtstovas(sasm_id, parent_atstovas_id, readonly = false) {
      this.modalAsmuo = {
        sasm_id: sasm_id,
        asm_asmens_kodas: this.isLocal ? '39000000000' : null,
        asm_fiz_vardas: this.isLocal ? 'PETRAS' : null,
        asm_fiz_pavarde: this.isLocal ? 'PETRAUSKAS' : null,
      }
      this.modalAsmuoReadonly = readonly
      this.modalAsmuoRole = 'atstovas'
      this.modalParentAtstovasId = parent_atstovas_id
      this.modalAsmuoKey =
        'asmuo' + (sasm_id ?? 'new' + this.modalAsmuoRefresh++)
      this.showAsmuo = true
    },
    savedAtstovas(modalAsmuo) {
      this.loading = true

      const data = {
        sasm_id: modalAsmuo.parent_atstovas_id,
        amn_id: modalAsmuo.amn_id,
      }

      this.$axios
        .post(
          `ntrpaslaugos/prasymas/${this.prasymasID}/asmuo/${modalAsmuo.parent_atstovas_id}/atstovas`,
          data
        )
        .then(res => {
          this.modalAsmuoKey = 'asmuo'
          window._VMA.$emit('DATA_OK', res.data.message)
          this.showAsmuo = false
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteAtstovas(item) {
      this.modalDeleteVardas = item.asm_pavadinimas
      this.modalDeleteItem = Object.assign({}, item)
      this.modalDeleteRole = 'atstovas'
      this.showDelete = true
    },
    mouseEnter(i) {
      this.activeRow = i
    },
    mouseLeave() {
      this.activeRow = null
    },
    forceHover(i) {
      if (this.activeRow === i) {
        return 'force-hover'
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.duomenys {
  padding-top: 10px;
  padding-bottom: 10px;

  p {
    padding: 3px 0px;
    margin: 0;
  }

  dl {
    display: flex;
    flex-flow: row wrap;
  }
  dt {
    flex-basis: 40%;
    padding: 2px 4px;
    text-align: right;
    font-weight: 400;
  }
  dd {
    flex-basis: 40%;
    flex-grow: 1;
    margin: 0;
    padding: 2px 4px;
    font-weight: 600;
  }
}
.table-no-bottom-border {
  border-bottom: none !important;
}
.force-hover {
  background: #eee;
}
</style>
